/**
 * Route constants for the application
 * Centralized route definitions to avoid magic strings
 */

/**
 * Authentication related routes
 */
export const AUTH_ROUTES = {
  LOGIN: '/login',
}

/**
 * Main application routes
 */
export const APP_ROUTES = {
  ROOT: '/',
  DASHBOARD: '/dashboard',
}

/**
 * Dashboard sub-routes
 * These are appended to the dashboard base route
 */
export const DASHBOARD_ROUTES = {
  ALL_SITES: 'sites',
  SITE: ':customer/:site',
  CONTROL_STATION: ':customer/:site/control-station/:controlStation',
  VEHICLE: ':customer/:site/vehicle/:vehicle',
}

/**
 * Route builders for navigation
 */
export const generatePath = {
  site: (customer, site) => `${APP_ROUTES.DASHBOARD}/${customer}/${site}`,
  vehicle: (customer, site, vehicle) =>
    `${APP_ROUTES.DASHBOARD}/${customer}/${site}/vehicle/${vehicle}`,
}
